<template>
  <el-form :model="profile" style="padding: 30px 0px 10px 40px" label-position="left" ref="profile"
           label-width="40%" class="demo-ruleForm">

    <el-form-item label="Email">
      <el-input type="name" style="width: 80%" v-model="profile.email" placeholder="Email"></el-input>
    </el-form-item>

    <el-form-item label="Old password">
      <el-input type="password" style="width: 80%" v-model="profile.oldPassword"
                placeholder="Old password"/>
    </el-form-item>

    <el-form-item label="New password">
      <el-input type="password" style="width: 80%" v-model="profile.newPassword" placeholder="New password"></el-input>
    </el-form-item>

    <el-form-item label="Confirm password">
      <el-input type="password" style="width: 80%" v-model="profile.confirmPassword"
                placeholder="Confirm password"></el-input>
    </el-form-item>

    <el-form-item>
      <el-button :loading="loading" type="primary" @click="submit()">Submit</el-button>
      <el-button @click="$emit('closeDialog')">Cancel</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
  import firebase from 'firebase'

  export default {
    name: "profile-security",
    data() {
      return {profile: {email: '', oldPassword: '', newPassword: '', confirmPassword: ''}, loading: false}

    },
    methods: {
      submit() {
        this.loading = true;
        firebase.auth().signInWithEmailAndPassword(this.profile.email, this.profile.oldPassword).then(user => {
          user.updatePassword(this.profile.newPassword).then(() => {

            this.$message.success('Password updated successfully!');
            this.loading = false;

          }).catch(() => {

            this.$message.error('Unable to update your password!');
            this.loading = false;
          })

        }).catch(err => {
          this.$message.error('Please verify your credentials!');
          this.loading = false;

        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/layout/components/profile/ProfileSecurity.vue